import { clearUsername, setLoadedTitle } from 'store/sessionSlice';
import STORIES from 'stories';
import { fetchTapes, loadMixById } from 'mixtape';

// Pull a display title out of a story: <AsciiTitle text="…">, else first
// heading, else first non-empty line.
const storyTitle = (md) => {
  const ascii = md.match(/<AsciiTitle[^>]*\btext=["']([^"']+)["']/);
  if (ascii) return ascii[1];
  const heading = md.match(/^#{1,6}\s+(.+)$/m);
  if (heading) return heading[1].trim();
  const line = md.split('\n').find((l) => l.trim());
  return line ? line.trim() : '';
};

// One-line usage per command, shown by `help`.
const usage = {
  help: 'help           — list commands',
  quit: 'quit           — reset',
  load: `load [name]    — load a story`,
  play: 'play [id]      — play a mixtape '
};

// Command registry. Add a command by adding a key here.
// Each handler receives { dispatch, navigate, output, args }.
const commands = {
  help: ({ output }) => {
    const lines = Object.keys(commands).map((c) => `  ${usage[c] || c}`);
    output(
      `Available Commands:\n<span style="font-family:c64Mono">${lines.join(
        '\n'
      )}</span>`
    );
  },
  quit: ({ dispatch }) => {
    dispatch(clearUsername());
    dispatch(setLoadedTitle(''));
    window.location.assign('/');
  },
  // load <name> -> fetches public/stories/<name>.md
  load: ({ output, args, navigate, dispatch }) => {
    const name = (args[0] || '').replace(/[^a-z0-9-]/g, '');
    if (!name) {
      output(`Load what?\n  -> ${STORIES.join('\n  -> ')}`);
      return;
    }
    if (navigate) navigate(`/${name}${window.location.search}`);
    fetch(`/stories/${name}.md`)
      .then((r) => {
        if (!r.ok) throw new Error('not found');
        return r.text();
      })
      .then((text) => {
        dispatch(setLoadedTitle(storyTitle(text)));
        output(text);
      })
      .catch(() => output(`No such story: ${name}`));
  },
  // play <id> -> loads a mixtape into the navbar player
  play: ({ output, args, dispatch }) => {
    const id = (args[0] || '').replace(/[^a-z0-9-]/gi, '');
    if (!id) {
      fetchTapes()
        .then((tapes) => {
          const list = tapes
            .map(
              (t) =>
                `  -> ${t.id}  ${t.artist ? `${t.artist} — ` : ''}${t.title}`
            )
            .join('\n');
          output(`Play what?\n${list}`);
        })
        .catch(() => output('Could not reach the mixtape archive.'));
      return;
    }
    loadMixById(dispatch, id)
      .then((mixtape) => {
        if (!mixtape) {
          output(`No such mixtape: ${id}`);
          return;
        }
        output(
          `▶ ${mixtape.title}${mixtape.artist ? ` — ${mixtape.artist}` : ''}\n` +
            'Controls are on the navbar player.'
        );
      })
      .catch(() => output(`Could not load mixtape: ${id}`));
  }
};

export const runCommand = (raw, ctx) => {
  const [name, ...args] = raw.trim().toLowerCase().split(/\s+/);
  if (!name) return;
  const command = commands[name];
  if (command) {
    command({ ...ctx, args });
  } else {
    ctx.output(`Unknown command: ${name}`);
  }
};

export default commands;
